var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodatauser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 633.37,
    height: 425.72,
    viewBox: "0 0 633.37 425.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "access-denied_5eefb_",
    transform: "translate(-5.32 -18.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5174",
    "data-name": "Group 5174",
    transform: "translate(5.32 18.32)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5170",
    "data-name": "Group 5170",
    transform: "translate(153.186 19.983)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_871",
    "data-name": "Ellipse 871",
    cx: 21.205,
    cy: 21.205,
    r: 21.205,
    fill: "#2f3a79"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_872",
    "data-name": "Ellipse 872",
    cx: 14.232,
    cy: 14.232,
    r: 14.232,
    transform: "translate(217.72 377.273)",
    fill: "#2f3a79"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_873",
    "data-name": "Ellipse 873",
    cx: 29.676,
    cy: 29.676,
    r: 29.676,
    transform: "translate(223.306 352.761)",
    fill: "#7b4a4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5171",
    "data-name": "Group 5171",
    transform: "translate(485.495 76.101)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_874",
    "data-name": "Ellipse 874",
    cx: 19.689,
    cy: 19.689,
    r: 19.689,
    transform: "translate(35.722)",
    fill: "#7b4a4a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_875",
    "data-name": "Ellipse 875",
    cx: 17.999,
    cy: 17.999,
    r: 17.999,
    transform: "translate(0 276.135)",
    fill: "#7b4a4a"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_876",
    "data-name": "Ellipse 876",
    cx: 13.249,
    cy: 13.249,
    r: 13.249,
    transform: "translate(164.652 377.402)",
    fill: "#b1f0ef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 13.249,
    cy: 13.249,
    r: 13.249,
    transform: "translate(69.799 83.626)",
    fill: "#7b4a4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5172",
    "data-name": "Group 5172",
    transform: "translate(0 249.978)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_878",
    "data-name": "Ellipse 878",
    cx: 20.691,
    cy: 20.691,
    r: 20.691,
    transform: "translate(0 0.9)",
    fill: "#fcfbac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_879",
    "data-name": "Ellipse 879",
    cx: 19.487,
    cy: 19.487,
    r: 19.487,
    transform: "translate(594.396)",
    fill: "#fcfbac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5173",
    "data-name": "Group 5173",
    transform: "translate(74.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_880",
    "data-name": "Ellipse 880",
    cx: 14.498,
    cy: 14.498,
    r: 14.498,
    transform: "translate(0 173.647)",
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_881",
    "data-name": "Ellipse 881",
    cx: 12.431,
    cy: 12.431,
    r: 12.431,
    transform: "translate(407.482)",
    fill: "#ff8080"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_882",
    "data-name": "Ellipse 882",
    cx: 19.028,
    cy: 19.028,
    r: 19.028,
    transform: "translate(311.857 19.689)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16162",
    "data-name": "Path 16162",
    d: "M215.786,287.316l-6.891-7.81a1.911,1.911,0,0,1-.4-2.38,24.33,24.33,0,0,0,1.672-5.32,2.655,2.655,0,0,1,2.343-2.536c3.124-.735,6.229-1.654,9.188-2.481a.689.689,0,0,0,.505-.744l-.854-9.243a.726.726,0,0,0-.661-.652l-11.025-.845a.8.8,0,0,1-.57-.358c-1.323-2.3-2.573-4.594-3.795-6.983a1.369,1.369,0,0,1-.083-1.1l5.568-9.721a.7.7,0,0,0-.184-.919l-7.166-5.816a.689.689,0,0,0-.919,0l-8.59,7.442a.68.68,0,0,1-.689.129,82.531,82.531,0,0,0-7.966-2.361.707.707,0,0,1-.505-.505c-.919-3.675-1.957-7.258-2.913-10.768a.717.717,0,0,0-.763-.514l-9.188.919a.717.717,0,0,0-.634.652l-.735,10.446a1.672,1.672,0,0,1-1.13,1.645c-2.049.965-4.024,2.113-5.972,3.234a1.47,1.47,0,0,1-1.764.083l-9.307-5.292a.7.7,0,0,0-.919.184l-5.853,7.166a.7.7,0,0,0,0,.919l7.166,8.269a1.773,1.773,0,0,1,.175,1.415,44.549,44.549,0,0,0-1.672,5.439,3.142,3.142,0,0,1-2.848,3.023c-3.05.7-6.046,1.654-8.848,2.444a.726.726,0,0,0-.505.763l.974,9.252a.707.707,0,0,0,.661.634l10.52.616a1.461,1.461,0,0,1,1.461.992,71.372,71.372,0,0,0,3.675,6.661.708.708,0,0,1,0,.735c-1.378,2.205-4.355,8.563-5.191,10.382a.707.707,0,0,0,.2.836l6.615,5.421a.7.7,0,0,0,.919,0l7.947-7c1.213-1.1,9.528,1.176,9.923,2.756s2.315,8.269,2.885,10.253a.689.689,0,0,0,.753.5l9.188-.919a.7.7,0,0,0,.643-.652l.606-10.364a1.838,1.838,0,0,1,1.314-1.9,43.928,43.928,0,0,0,5.513-2.9c.864-.524,1.47-.809,2.407-.147s7.35,4.134,9.188,5.145a.7.7,0,0,0,.919-.184l5.788-7.093a.707.707,0,0,0-.119-.854Zm-44.3-10.52a14.507,14.507,0,1,1,20.387-2.049A14.507,14.507,0,0,1,171.483,276.8Z",
    transform: "translate(-10.864 -16.694)",
    fill: "#ffd1d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175",
    transform: "translate(174.557 131.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    d: "M200.49,141H466.2c6.275,0,10.979,2.756,10.979,10.933V328.612A10.961,10.961,0,0,1,466.2,339.555H200.49c-6.486,0-10.97-3.4-10.97-10.933v-176.6C189.52,143.15,195.29,141,200.49,141Z",
    transform: "translate(-189.52 -141)",
    fill: "#7e7e7e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    d: "M202.339,143.15H464.665c6.891,0,10.841,2.591,10.841,10.272V319.415c0,11.025,1.011,10.272-10.841,10.272H202.339c-11.944,0-10.841.781-10.841-10.272V153.422C191.5,144.271,197.718,143.15,202.339,143.15Z",
    transform: "translate(-189.678 -141.175)",
    fill: "#333",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16166",
    "data-name": "Path 16166",
    d: "M199.8,154.385l268.62-.165V322.492H199.8Z",
    transform: "translate(-15.798 -11.04)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16167",
    "data-name": "Path 16167",
    d: "M484.1,360.922c8.269-1.194,11.255-3.9,11.255-3.9V350.65H167.8v6.376c3.179,2.021,6.431,3.675,14.9,4.594C189.961,362.465,475.394,362.842,484.1,360.922Z",
    transform: "translate(-13.199 -26.996)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16168",
    "data-name": "Path 16168",
    d: "M167.8,350.53H495.359v6.45H167.8Z",
    transform: "translate(-13.199 -26.986)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16169",
    "data-name": "Path 16169",
    d: "M368.128,350.528h-49c.643,2.435,2.426,4.2,3.822,4.2h41.841c1.406,0,3.124-1.773,3.739-4.226Z",
    transform: "translate(-25.492 -26.984)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16170",
    "data-name": "Path 16170",
    d: "M347.787,148.985a1.654,1.654,0,1,1-1.654-1.645,1.654,1.654,0,0,1,1.654,1.645Z",
    transform: "translate(-27.551 -10.481)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_883",
    "data-name": "Ellipse 883",
    cx: 35.667,
    cy: 35.667,
    r: 35.667,
    transform: "translate(274.932 172.875)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_884",
    "data-name": "Ellipse 884",
    cx: 35.667,
    cy: 35.667,
    r: 35.667,
    transform: "translate(282.32 170.275)",
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16173",
    "data-name": "Path 16173",
    d: "M383.787,286.106H300.758a1.378,1.378,0,0,1,0-2.756h83.029a1.378,1.378,0,0,1,0,2.756ZM364.2,302.231H320.346a1.378,1.378,0,1,1,0-2.756h43.862a1.378,1.378,0,1,1,0,2.756Z",
    transform: "translate(-23.887 -21.529)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5168",
    "data-name": "Group 5168",
    transform: "translate(302.811 190.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14513",
    "data-name": "Path 14513",
    d: "M38.752,37.241l-1.9-1.1v.73H9.628V9.65h.73l-1.1-1.9-1.1,1.9h.73v2.267H7.75v.734H8.895v1.537H7.75v.734H8.895v1.534H7.75v.734H8.895v1.534H7.75v.734H8.895v1.537H7.75v.734H8.895v1.534H7.75V24H8.895V25.53H7.75v.734H8.895V27.8H7.75v.734H8.895v1.534H7.75V30.8H8.895v1.534H7.75v.734H8.895v1.537H7.75v.734H8.895v1.534H7.75v.734H8.895v1.145h.734V37.608h1.534v1.145H11.9V37.608h1.537v1.145h.734V37.608H15.7v1.145h.734V37.608h1.534v1.145H18.7V37.608h1.537v1.145h.734V37.608h1.534v1.145h.734V37.608h1.534v1.145h.734V37.608h1.537v1.145h.734V37.608h1.534v1.145h.734V37.608H31.58v1.145h.734V37.608h1.537v1.145h.734V37.608h2.267v.73Z",
    transform: "translate(-7.75 -7.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2613",
    "data-name": "Rectangle 2613",
    width: 3.761,
    height: 9.792,
    rx: 1,
    transform: "translate(3.412 17.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14514",
    "data-name": "Path 14514",
    d: "M31.847,58.177H34.87a.367.367,0,0,0,.367-.367V44.217a.367.367,0,0,0-.367-.367H31.847a.367.367,0,0,0-.367.367V57.81A.367.367,0,0,0,31.847,58.177Zm.367-13.6H34.5V57.443H32.214V44.584Z",
    transform: "translate(-22.774 -30.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2614",
    "data-name": "Rectangle 2614",
    width: 3.757,
    height: 13.197,
    rx: 1,
    transform: "translate(14.001 14.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14515",
    "data-name": "Path 14515",
    d: "M60.707,53.448H63.73a.367.367,0,0,0,.367-.367V36.747a.367.367,0,0,0-.367-.367H60.707a.367.367,0,0,0-.367.367V53.081A.367.367,0,0,0,60.707,53.448Zm.367-16.334h2.289v15.6H61.074Z",
    transform: "translate(-41.045 -25.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2615",
    "data-name": "Rectangle 2615",
    width: 3.761,
    height: 19.625,
    rx: 1,
    transform: "translate(24.585 7.951)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5181",
    "data-name": "Group 5181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179",
    transform: "translate(385.281 254.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5178",
    "data-name": "Group 5178",
    transform: "translate(0 57.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16175",
    "data-name": "Path 16175",
    d: "M497.342,349.523c-4.272-2.646-13.2-4.915-20.828-9.61a6.954,6.954,0,0,0-2.407-.992h-.413a12.761,12.761,0,0,1-18.513,0h-.257a6.954,6.954,0,0,0-2.407.992c-7.626,4.686-16.538,6.964-20.838,9.61-8.563,5.3-10.2,22.106-10.2,22.106s10.841,4.594,43.044,5.7c32.708,0,43.035-5.7,43.035-5.7s-1.654-16.813-10.2-22.106Z",
    transform: "translate(-421.48 -338.92)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16176",
    "data-name": "Path 16176",
    d: "M474.682,377.392l-5.88-27.673,2.205-3.124a2.756,2.756,0,0,0,0-3.161l-1.69-2.325h-5.053l-1.654,2.664a2.757,2.757,0,0,0,.11,2.958l1.93,2.756-4.87,27.627,7.286.331,7.607-.046Z",
    transform: "translate(-424.592 -339.097)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5177",
    "data-name": "Group 5177",
    transform: "translate(15.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16177",
    "data-name": "Path 16177",
    d: "M.07.7C11-2.084,31.684-8.267,41.955,2.73c5.961,12.381,1.146,31.984-.8,41.958C30.72,49.5,19.256,51.566,5.73,44-1.493,30.129-.576,11.443.07.7Z",
    transform: "translate(4.5 8.439)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16178",
    "data-name": "Path 16178",
    d: "M378.021,243.954c.019-.075,2.655-1.678,3.908-1.028s1.36,2.29,1.1,3.627a3.679,3.679,0,0,1-1.365,2.113l-.6,1.271L380.9,251l-.131,1.215-.28,1.888-.486,1.44a1.53,1.53,0,0,1-.71.71,1.764,1.764,0,0,1-1.047-.112v-8.919Z",
    transform: "translate(-330.354 -211.481)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16179",
    "data-name": "Path 16179",
    d: "M343.729,245.548l-.442-3.95-2.117-1.58-1.99,1.3-.727,3,.885,3.191.538,3.6.694,3.445.854,1.706,1.548.443,1.263-1.107.221-5.34Z",
    transform: "translate(-338.134 -212.022)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5176",
    "data-name": "Group 5176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_39",
    "data-name": "Exclusion 39",
    d: "M.211,3.612C.794,3.029,8-3.739,12.094,2.892,11.706,7.911,1.217,4.276.807,4.13S-.373,4.2.211,3.612Z",
    transform: "translate(30.592 30.155)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15218",
    "data-name": "Path 15218",
    d: "M14792.644,5324.976a15.985,15.985,0,0,0-15.631,4.314,131.516,131.516,0,0,0,1.625,19.32,6.857,6.857,0,0,1,1.688,4.876c1.688-2.625.688-4.126.688-4.126a23.376,23.376,0,0,1,2.314-5.064c-.187-2.376-1.25-1.25-.625-9.566,1.625-4.5,12.066-3.939,18.008-.5a4.8,4.8,0,0,0,1.982.6,5.164,5.164,0,0,0,1.928-.6s19.549-5.516,17.646,6.953c-1.355,3.043-1.91,2.821-1.91,2.821a13.663,13.663,0,0,1,1.91,3.293c.164.962-1.059,2.072-.244,6.956.777-3,1.48-3.329,3.107-3.441.443-3.034.3-6.03,1.553-9.471s-2-12.431-8.434-12.986c-4.477-4.846-12.357-12.356-31.375-4.476Z",
    transform: "translate(-14774.872 -5320.449)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15219",
    "data-name": "Path 15219",
    d: "M15367.521,5892.338c.221,0,5.2-4,8.842-4,1.592.037,5.439,4,5.439,4a38.256,38.256,0,0,0-6.771-2.072A18.709,18.709,0,0,0,15367.521,5892.338Z",
    transform: "translate(-15337.427 -5861.458)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15220",
    "data-name": "Path 15220",
    d: "M14926.932,5875.865a25.544,25.544,0,0,1,2.67-2.233,1.118,1.118,0,0,1,.68-.329,3.5,3.5,0,0,1,1.072.132s9.02,4.137,11.361,3.5c-3.9.964-11.361-1.138-11.361-1.138a6.328,6.328,0,0,0-1.072-.416c-.35-.066-1.732,1.234-1.949,1.313a1.477,1.477,0,0,1-1.027-.219C14926.953,5876.271,14926.861,5876.129,14926.932,5875.865Z",
    transform: "translate(-14917.675 -5847.122)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_27",
    "data-name": "Exclusion 27",
    d: "M22.039,29.755h0a4.063,4.063,0,0,1-.71-.056s-.508-.1-1.388-.336c-.513-.138-1.05-.3-1.6-.468-.682-.216-1.379-.455-2.073-.712a48.757,48.757,0,0,1-5.2-2.282c-1-.511-1.993-1.061-2.945-1.635-1.047-.631-2.074-1.306-3.05-2.007A9.769,9.769,0,0,1,3.678,21.04a10.557,10.557,0,0,1-1.129-1.425,12.273,12.273,0,0,1-.887-1.593A14.866,14.866,0,0,1,.992,16.3,23.9,23.9,0,0,1,0,8.925c.005-1.1.065-2.256.177-3.432.09-.941.213-1.9.367-2.842C.807,1.04,1.069.01,1.071,0A31.247,31.247,0,0,0,2.532,11.38a15.923,15.923,0,0,0,3.834,6.209,12.627,12.627,0,0,0,2.1,1.65,11.6,11.6,0,0,0,1.851.938,9.662,9.662,0,0,0,1.317.421,5,5,0,0,0,.5.1c-.006,0-.035-.024-.07-.11A2.156,2.156,0,0,1,11.95,20a11.283,11.283,0,0,1-.023-1.441c.026-.736.1-1.637.211-2.678a14.716,14.716,0,0,1,1.886-.85,15.157,15.157,0,0,1,1.9-.559,16.208,16.208,0,0,1,1.877-.307,17.723,17.723,0,0,1,1.832-.094,20.626,20.626,0,0,1,3.82.371,24.112,24.112,0,0,1,3.125.815c.92.306,1.655.612,2.109.815.486.217.763.364.774.371l1.25,5.064c.007,0,.756-.095,1.938-.3.69-.123,1.387-.26,2.071-.407.856-.185,1.694-.387,2.493-.6a1.584,1.584,0,0,0,.632-.362,3.53,3.53,0,0,0,.585-.7,7.656,7.656,0,0,0,.539-.992c.167-.362.332-.776.493-1.231a41.467,41.467,0,0,0,1.534-6.318c.182-1.029.356-2.137.517-3.293.129-.925.25-1.884.36-2.849.185-1.624.276-2.714.279-2.76v.006c.032.2.2,1.26.4,2.807.13.991.249,1.982.354,2.948.13,1.206.238,2.374.32,3.47a52.138,52.138,0,0,1,.135,6.992c-.034.534-.083,1.033-.145,1.483a11.921,11.921,0,0,1-.242,1.282,6.057,6.057,0,0,1-.352,1.034,2.759,2.759,0,0,1-.474.738,4.94,4.94,0,0,1-.671.581,10.272,10.272,0,0,1-.909.589,23.4,23.4,0,0,1-2.378,1.178c-1.576.687-3.563,1.42-5.9,2.178-2.083.674-4.068,1.244-5.365,1.6-1.413.391-2.332.622-2.341.624s-.251.095-.6.2a8.824,8.824,0,0,1-1.207.3A4.857,4.857,0,0,1,22.039,29.755Zm5.09-11.166h0s-.281.17-.689.449c-.376.257-.942.664-1.5,1.138a9.268,9.268,0,0,0-1.472,1.512,2.427,2.427,0,0,0-.595,1.571c.051.6.522,1.087,1.4,1.435.221.016.442.025.657.025a7.544,7.544,0,0,0,1.816-.214,6.238,6.238,0,0,0,1.287-.471,4.962,4.962,0,0,0,.767-.471,2.545,2.545,0,0,0,.254-.214l-1.924-4.761ZM14.72,17.531h0l-.914,4.425a3.411,3.411,0,0,0,.212.408,4.934,4.934,0,0,0,.686.9,4.192,4.192,0,0,0,3.1,1.306h0c.125,0,.253,0,.382-.014.81-.321,1.254-.788,1.32-1.389a2.839,2.839,0,0,0-.644-1.826A11.376,11.376,0,0,0,17.2,19.507c-.633-.583-1.275-1.089-1.7-1.411-.455-.344-.768-.556-.782-.565Z",
    transform: "translate(5.132 31.663)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15225",
    "data-name": "Path 15225",
    d: "M15197.136,6372.059a5.2,5.2,0,0,0,4.439,1.738c3.07-.148,3.994-1.554,3.994-1.554Z",
    transform: "translate(-15175.108 -6322.272)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15226",
    "data-name": "Path 15226",
    d: "M15203.68,6313.344a17.9,17.9,0,0,0,2.764-1.273,1.241,1.241,0,0,0,.141-.149c.037-.039.1-.038.162-.057,2.2-.68,4.59,1.793,4.59,1.793Z",
    transform: "translate(-15181.343 -6264.816)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15227",
    "data-name": "Path 15227",
    d: "M15447.426,6012c-.428-.5-.027-.769-.4-1.167s.939-.427,1.139.17a5.013,5.013,0,0,0,.709,1.594c.174.057.143.313-.143.227A2.92,2.92,0,0,1,15447.426,6012Z",
    transform: "translate(-15413.107 -5977.876)",
    fill: "#dedede",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15228",
    "data-name": "Path 15228",
    d: "M15556.548,6000.063s1.025-1.172,1.594,0a1.561,1.561,0,0,1-.654,1.94s-.881.2-.625-.512A1.671,1.671,0,0,0,15556.548,6000.063Z",
    transform: "translate(-15517.505 -5967.392)",
    fill: "#dedede",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_33",
    "data-name": "Exclusion 33",
    d: "M2.036,4.071A2.036,2.036,0,0,1,1.243.16,2.036,2.036,0,0,1,2.828,3.911,2.023,2.023,0,0,1,2.036,4.071Zm0-2.683a.648.648,0,1,0,.648.648A.648.648,0,0,0,2.036,1.388Z",
    transform: "translate(35.372 31.509)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15813",
    "data-name": "Path 15813",
    d: "M15117.574,6165.648s3.191-1.988,3.492-2.891c0,0,.307.868.475,0s1.518.564,1.518.564-.738-.38-.717.422-.357.337-.357.674.146.7.59.381,1.434-.317,1.939-1.687c.76-.042.611.633.611.633s-1.623.843-.611,1.5c0,0-.654,2.4,4.449,1.243,0,0,.295-.442-.295-1.1.971-.4,1.623-.274,2.15,1.1,1.1-.759-.148-2.74-.148-2.74s-.316-.549,0-.78,1.584.843,1.771,2.277a16.06,16.06,0,0,1,3.311,2.214s-3.016-2.172-3.311-1.855c0,.484.338.484.295.653a2.413,2.413,0,0,1-.588.78c-.148.084-.465-.991-.949,0a2.473,2.473,0,0,0-2.531.084,4.649,4.649,0,0,1-4.471-.759c-.287-.254-.357-.633-.906-.59,0,0,.084,1.349-1.307.295s-1.266-1.982-1.266-1.982a10.16,10.16,0,0,1-1.393.844A16.961,16.961,0,0,1,15117.574,6165.648Z",
    transform: "translate(-15099.313 -6122.614)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15814",
    "data-name": "Path 15814",
    d: "M15295.793,6020.013c-.221,0-.166,3.975-.549,4.276C15295.244,6024.289,15296.01,6020.013,15295.793,6020.013Z",
    transform: "translate(-15268.571 -5986.894)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15823",
    "data-name": "Path 15823",
    d: "M.211,1.936A10.842,10.842,0,0,0,11.6,4.687C9.566-3.26,1.217,1.272.807,1.418S-.373,1.352.211,1.936Z",
    transform: "translate(22.092 35.608) rotate(180)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882",
    transform: "translate(30.592 30.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_32",
    "data-name": "Exclusion 32",
    d: "M7.99,5.538h0a15.8,15.8,0,0,1-2.408-.208c-.713-.111-1.475-.267-2.265-.464C1.882,4.511.85,4.146.807,4.13a1.706,1.706,0,0,0-.42-.066C.2,4.05.036,4.038.005,3.955s.04-.177.206-.343c.052-.052.337-.333.815-.731A16.742,16.742,0,0,1,2.694,1.658,12.291,12.291,0,0,1,4.932.509,8.35,8.35,0,0,1,6.177.139,6.273,6.273,0,0,1,7.46,0,5.041,5.041,0,0,1,8.693.149a4.72,4.72,0,0,1,1.2.49,5.458,5.458,0,0,1,1.144.893,7.649,7.649,0,0,1,1.053,1.359,3,3,0,0,1-.134.7,2.4,2.4,0,0,1-.274.574,2.337,2.337,0,0,1-.4.46,2.757,2.757,0,0,1-.506.355,4.3,4.3,0,0,1-1.274.433A8.258,8.258,0,0,1,7.99,5.538ZM7.28.493a7.592,7.592,0,0,0-4,1.391A13.56,13.56,0,0,0,1.2,3.524c-.139.139-.194.23-.173.288s.162.08.32.092a1.432,1.432,0,0,1,.352.055c.036.013.9.319,2.106.618a16.717,16.717,0,0,0,3.921.563h0a4.909,4.909,0,0,0,2.343-.47,2.063,2.063,0,0,0,1.1-1.75A4.475,4.475,0,0,0,7.28.493Z",
    transform: "translate(0 0)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15815",
    "data-name": "Path 15815",
    d: "M15381.754,6039.743s1.223,1.792,2.213,1.813c0,0-1.158-1.054-1.074-1.666S15381.754,6039.743,15381.754,6039.743Z",
    transform: "translate(-15381.577 -6035.684)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "translate(10.495 30.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_32-2",
    "data-name": "Exclusion 32",
    d: "M7.938,5.251h0a10.875,10.875,0,0,1-1.584-.115,10.475,10.475,0,0,1-1.409-.309A10.558,10.558,0,0,1,2.658,3.85,10.937,10.937,0,0,1,.268,1.993L.211,1.936C.045,1.77-.02,1.661.005,1.593S.2,1.5.387,1.484a1.706,1.706,0,0,0,.42-.066c.027-.01.09-.039.184-.083A16.44,16.44,0,0,1,2.952.552,10.42,10.42,0,0,1,6.117,0,6.239,6.239,0,0,1,7.785.214a5.007,5.007,0,0,1,.8.3,4.681,4.681,0,0,1,.757.45,4.824,4.824,0,0,1,.7.623,5.533,5.533,0,0,1,.619.815,6.969,6.969,0,0,1,.525,1.028,9.37,9.37,0,0,1,.414,1.26,13.707,13.707,0,0,1-1.914.432A11.874,11.874,0,0,1,7.938,5.251ZM5.6.652a9.35,9.35,0,0,0-3.78.884c-.062.028-.1.046-.124.053a1.432,1.432,0,0,1-.352.055c-.158.012-.294.022-.32.092s.034.149.173.288a5.346,5.346,0,0,0,.849.58A16.463,16.463,0,0,0,3.791,3.5,12.79,12.79,0,0,0,8.713,4.672h0a6.488,6.488,0,0,0,2.456-.448A6.073,6.073,0,0,0,5.6.652Z",
    transform: "translate(11.597 5.251) rotate(180)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15815-2",
    "data-name": "Path 15815",
    d: "M15383.967,6039.743s-1.221,1.792-2.213,1.813c0,0,1.16-1.054,1.076-1.666S15383.967,6039.743,15383.967,6039.743Z",
    transform: "translate(-15372.547 -6035.981)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15816",
    "data-name": "Path 15816",
    d: "M14751.916,5968.24s-.369-3.613,1.811-2.919,1.063,4.864,0,4.726-.047,2.455,1.156,2.548,1.529,2.085,1.529,2.085",
    transform: "translate(-14750.943 -5934.707)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15817",
    "data-name": "Path 15817",
    d: "M14737.686,5910.951a4.443,4.443,0,0,1-1.389-3.336c.047-2.131-2.131-2.918-3.15-.6s.7,5.049.789,5.884,1.111,9.635,3.01,7.644.74.6.74.6-3.1,2.6-4.076-3.659-.463-5.328-1.76-8.478c.232-3.2,1.018-4.494,2.688-4.679s2.779,3.011,2.779,3.011l.369,1.668Z",
    transform: "translate(-14731.85 -5876.677)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15818",
    "data-name": "Path 15818",
    d: "M15728.141,5975.363s2.137,1.083,2.424-4.976c.391-3.1,1.781-3.706,1.924-3.848s1.391-4.74-2.211-4.419c0,0-2.457.749-2.137,5.667l-.82-4.027s.82-3.848,4.17-2.708,1.6,5.488,1.6,5.488-1.568.535-2.209,3.848c-.248,1.276-.373,3.444-.855,4.241A1.493,1.493,0,0,1,15728.141,5975.363Z",
    transform: "translate(-15680.191 -5930.522)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15819",
    "data-name": "Path 15819",
    d: "M15743.654,6001.433v-.512s1.176,1.888,1.5,1.354.643-1.247-.283-1.782-2.246,1.568-1.891,2.887,2.209,1.247.678,2.922c0,0-1.461,1.069-2.031.784,0,0,2.887-2.031,1.354-2.815a2.26,2.26,0,0,1-.963-2.637s.572-2,2.068-1.853a2.346,2.346,0,0,1,1.961,1.141s.426,1.425-.607,1.853S15743.654,6001.433,15743.654,6001.433Z",
    transform: "translate(-15693.817 -5967.612)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15821",
    "data-name": "Path 15821",
    d: "M15006.152,6003.643c-.295.632.76.4,1.117.886s.125-.548.125-.548S15006.447,6003.01,15006.152,6003.643Z",
    transform: "translate(-14993.116 -5971.095)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15822",
    "data-name": "Path 15822",
    d: "M15110.9,6007.365s.254,1.054,0,1.413,1.477.042,1.477-.8-1.477-.612-1.477-.612",
    transform: "translate(-15092.933 -5974.817)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_40",
    "data-name": "Exclusion 40",
    d: "M2.036,4.071A2.036,2.036,0,0,1,1.243.16,2.036,2.036,0,0,1,2.828,3.911,2.023,2.023,0,0,1,2.036,4.071Zm0-2.683a.648.648,0,1,0,.648.648A.648.648,0,0,0,2.036,1.388Z",
    transform: "translate(14.21 31.178)",
    fill: "#dedede"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5180",
    "data-name": "Group 5180",
    transform: "translate(387.675 255.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5178-2",
    "data-name": "Group 5178",
    transform: "translate(0 57.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16175-2",
    "data-name": "Path 16175",
    d: "M497.342,349.523c-4.272-2.646-13.2-4.915-20.828-9.61a6.954,6.954,0,0,0-2.407-.992h-.413a12.761,12.761,0,0,1-18.513,0h-.257a6.954,6.954,0,0,0-2.407.992c-7.626,4.686-16.538,6.964-20.838,9.61-8.563,5.3-10.2,22.106-10.2,22.106s10.841,4.594,43.044,5.7c32.708,0,43.035-5.7,43.035-5.7s-1.654-16.813-10.2-22.106Z",
    transform: "translate(-421.48 -338.92)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16176-2",
    "data-name": "Path 16176",
    d: "M474.682,377.392l-5.88-27.673,2.205-3.124a2.756,2.756,0,0,0,0-3.161l-1.69-2.325h-5.053l-1.654,2.664a2.757,2.757,0,0,0,.11,2.958l1.93,2.756-4.87,27.627,7.286.331,7.607-.046Z",
    transform: "translate(-424.592 -339.097)",
    fill: "#e9f1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5177-2",
    "data-name": "Group 5177",
    transform: "translate(15.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16177-2",
    "data-name": "Path 16177",
    d: "M.07.7C11-2.084,31.684-8.267,41.955,2.73c5.961,12.381,1.146,31.984-.8,41.958C30.72,49.5,19.256,51.566,5.73,44-1.493,30.129-.576,11.443.07.7Z",
    transform: "translate(4.5 8.439)",
    fill: "#feeacc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16178-2",
    "data-name": "Path 16178",
    d: "M378.021,243.954c.019-.075,2.655-1.678,3.908-1.028s1.36,2.29,1.1,3.627a3.679,3.679,0,0,1-1.365,2.113l-.6,1.271L380.9,251l-.131,1.215-.28,1.888-.486,1.44a1.53,1.53,0,0,1-.71.71,1.764,1.764,0,0,1-1.047-.112v-8.919Z",
    transform: "translate(-330.354 -211.481)",
    fill: "#feeacc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16179-2",
    "data-name": "Path 16179",
    d: "M343.729,245.548l-.442-3.95-2.117-1.58-1.99,1.3-.727,3,.885,3.191.538,3.6.694,3.445.854,1.706,1.548.443,1.263-1.107.221-5.34Z",
    transform: "translate(-338.134 -212.022)",
    fill: "#feeacc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5176-2",
    "data-name": "Group 5176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_39-2",
    "data-name": "Exclusion 39",
    d: "M.211,3.612C.794,3.029,8-3.739,12.094,2.892,11.706,7.911,1.217,4.276.807,4.13S-.373,4.2.211,3.612Z",
    transform: "translate(30.592 30.155)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15218-2",
    "data-name": "Path 15218",
    d: "M14792.644,5324.976a15.985,15.985,0,0,0-15.631,4.314,131.516,131.516,0,0,0,1.625,19.32,6.857,6.857,0,0,1,1.688,4.876c1.688-2.625.688-4.126.688-4.126a23.376,23.376,0,0,1,2.314-5.064c-.187-2.376-1.25-1.25-.625-9.566,1.625-4.5,12.066-3.939,18.008-.5a4.8,4.8,0,0,0,1.982.6,5.164,5.164,0,0,0,1.928-.6s19.549-5.516,17.646,6.953c-1.355,3.043-1.91,2.821-1.91,2.821a13.663,13.663,0,0,1,1.91,3.293c.164.962-1.059,2.072-.244,6.956.777-3,1.48-3.329,3.107-3.441.443-3.034.3-6.03,1.553-9.471s-2-12.431-8.434-12.986c-4.477-4.846-12.357-12.356-31.375-4.476Z",
    transform: "translate(-14774.872 -5320.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15219-2",
    "data-name": "Path 15219",
    d: "M15367.521,5892.338c.221,0,5.2-4,8.842-4,1.592.037,5.439,4,5.439,4a38.256,38.256,0,0,0-6.771-2.072A18.709,18.709,0,0,0,15367.521,5892.338Z",
    transform: "translate(-15337.427 -5861.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15220-2",
    "data-name": "Path 15220",
    d: "M14926.932,5875.865a25.544,25.544,0,0,1,2.67-2.233,1.118,1.118,0,0,1,.68-.329,3.5,3.5,0,0,1,1.072.132s9.02,4.137,11.361,3.5c-3.9.964-11.361-1.138-11.361-1.138a6.328,6.328,0,0,0-1.072-.416c-.35-.066-1.732,1.234-1.949,1.313a1.477,1.477,0,0,1-1.027-.219C14926.953,5876.271,14926.861,5876.129,14926.932,5875.865Z",
    transform: "translate(-14917.675 -5847.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_27-2",
    "data-name": "Exclusion 27",
    d: "M22.039,29.755h0a4.063,4.063,0,0,1-.71-.056s-.508-.1-1.388-.336c-.513-.138-1.05-.3-1.6-.468-.682-.216-1.379-.455-2.073-.712a48.757,48.757,0,0,1-5.2-2.282c-1-.511-1.993-1.061-2.945-1.635-1.047-.631-2.074-1.306-3.05-2.007A9.769,9.769,0,0,1,3.678,21.04a10.557,10.557,0,0,1-1.129-1.425,12.273,12.273,0,0,1-.887-1.593A14.866,14.866,0,0,1,.992,16.3,23.9,23.9,0,0,1,0,8.925c.005-1.1.065-2.256.177-3.432.09-.941.213-1.9.367-2.842C.807,1.04,1.069.01,1.071,0A31.247,31.247,0,0,0,2.532,11.38a15.923,15.923,0,0,0,3.834,6.209,12.627,12.627,0,0,0,2.1,1.65,11.6,11.6,0,0,0,1.851.938,9.662,9.662,0,0,0,1.317.421,5,5,0,0,0,.5.1c-.006,0-.035-.024-.07-.11A2.156,2.156,0,0,1,11.95,20a11.283,11.283,0,0,1-.023-1.441c.026-.736.1-1.637.211-2.678a14.716,14.716,0,0,1,1.886-.85,15.157,15.157,0,0,1,1.9-.559,16.208,16.208,0,0,1,1.877-.307,17.723,17.723,0,0,1,1.832-.094,20.626,20.626,0,0,1,3.82.371,24.112,24.112,0,0,1,3.125.815c.92.306,1.655.612,2.109.815.486.217.763.364.774.371l1.25,5.064c.007,0,.756-.095,1.938-.3.69-.123,1.387-.26,2.071-.407.856-.185,1.694-.387,2.493-.6a1.584,1.584,0,0,0,.632-.362,3.53,3.53,0,0,0,.585-.7,7.656,7.656,0,0,0,.539-.992c.167-.362.332-.776.493-1.231a41.467,41.467,0,0,0,1.534-6.318c.182-1.029.356-2.137.517-3.293.129-.925.25-1.884.36-2.849.185-1.624.276-2.714.279-2.76v.006c.032.2.2,1.26.4,2.807.13.991.249,1.982.354,2.948.13,1.206.238,2.374.32,3.47a52.138,52.138,0,0,1,.135,6.992c-.034.534-.083,1.033-.145,1.483a11.921,11.921,0,0,1-.242,1.282,6.057,6.057,0,0,1-.352,1.034,2.759,2.759,0,0,1-.474.738,4.94,4.94,0,0,1-.671.581,10.272,10.272,0,0,1-.909.589,23.4,23.4,0,0,1-2.378,1.178c-1.576.687-3.563,1.42-5.9,2.178-2.083.674-4.068,1.244-5.365,1.6-1.413.391-2.332.622-2.341.624s-.251.095-.6.2a8.824,8.824,0,0,1-1.207.3A4.857,4.857,0,0,1,22.039,29.755Zm5.09-11.166h0s-.281.17-.689.449c-.376.257-.942.664-1.5,1.138a9.268,9.268,0,0,0-1.472,1.512,2.427,2.427,0,0,0-.595,1.571c.051.6.522,1.087,1.4,1.435.221.016.442.025.657.025a7.544,7.544,0,0,0,1.816-.214,6.238,6.238,0,0,0,1.287-.471,4.962,4.962,0,0,0,.767-.471,2.545,2.545,0,0,0,.254-.214l-1.924-4.761ZM14.72,17.531h0l-.914,4.425a3.411,3.411,0,0,0,.212.408,4.934,4.934,0,0,0,.686.9,4.192,4.192,0,0,0,3.1,1.306h0c.125,0,.253,0,.382-.014.81-.321,1.254-.788,1.32-1.389a2.839,2.839,0,0,0-.644-1.826A11.376,11.376,0,0,0,17.2,19.507c-.633-.583-1.275-1.089-1.7-1.411-.455-.344-.768-.556-.782-.565Z",
    transform: "translate(5.132 31.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15225-2",
    "data-name": "Path 15225",
    d: "M15197.136,6372.059a5.2,5.2,0,0,0,4.439,1.738c3.07-.148,3.994-1.554,3.994-1.554Z",
    transform: "translate(-15175.108 -6322.272)",
    fill: "#ffb7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15226-2",
    "data-name": "Path 15226",
    d: "M15203.68,6313.344a17.9,17.9,0,0,0,2.764-1.273,1.241,1.241,0,0,0,.141-.149c.037-.039.1-.038.162-.057,2.2-.68,4.59,1.793,4.59,1.793Z",
    transform: "translate(-15181.343 -6264.816)",
    fill: "#ffb7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15227-2",
    "data-name": "Path 15227",
    d: "M15447.426,6012c-.428-.5-.027-.769-.4-1.167s.939-.427,1.139.17a5.013,5.013,0,0,0,.709,1.594c.174.057.143.313-.143.227A2.92,2.92,0,0,1,15447.426,6012Z",
    transform: "translate(-15413.107 -5977.876)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15228-2",
    "data-name": "Path 15228",
    d: "M15556.548,6000.063s1.025-1.172,1.594,0a1.561,1.561,0,0,1-.654,1.94s-.881.2-.625-.512A1.671,1.671,0,0,0,15556.548,6000.063Z",
    transform: "translate(-15517.505 -5967.392)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_33-2",
    "data-name": "Exclusion 33",
    d: "M2.036,4.071A2.036,2.036,0,0,1,1.243.16,2.036,2.036,0,0,1,2.828,3.911,2.023,2.023,0,0,1,2.036,4.071Zm0-2.683a.648.648,0,1,0,.648.648A.648.648,0,0,0,2.036,1.388Z",
    transform: "translate(35.372 31.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15813-2",
    "data-name": "Path 15813",
    d: "M15117.574,6165.648s3.191-1.988,3.492-2.891c0,0,.307.868.475,0s1.518.564,1.518.564-.738-.38-.717.422-.357.337-.357.674.146.7.59.381,1.434-.317,1.939-1.687c.76-.042.611.633.611.633s-1.623.843-.611,1.5c0,0-.654,2.4,4.449,1.243,0,0,.295-.442-.295-1.1.971-.4,1.623-.274,2.15,1.1,1.1-.759-.148-2.74-.148-2.74s-.316-.549,0-.78,1.584.843,1.771,2.277a16.06,16.06,0,0,1,3.311,2.214s-3.016-2.172-3.311-1.855c0,.484.338.484.295.653a2.413,2.413,0,0,1-.588.78c-.148.084-.465-.991-.949,0a2.473,2.473,0,0,0-2.531.084,4.649,4.649,0,0,1-4.471-.759c-.287-.254-.357-.633-.906-.59,0,0,.084,1.349-1.307.295s-1.266-1.982-1.266-1.982a10.16,10.16,0,0,1-1.393.844A16.961,16.961,0,0,1,15117.574,6165.648Z",
    transform: "translate(-15099.313 -6122.614)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15814-2",
    "data-name": "Path 15814",
    d: "M15295.793,6020.013c-.221,0-.166,3.975-.549,4.276C15295.244,6024.289,15296.01,6020.013,15295.793,6020.013Z",
    transform: "translate(-15268.571 -5986.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15823-2",
    "data-name": "Path 15823",
    d: "M.211,1.936A10.842,10.842,0,0,0,11.6,4.687C9.566-3.26,1.217,1.272.807,1.418S-.373,1.352.211,1.936Z",
    transform: "translate(22.092 35.608) rotate(180)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4882-2",
    "data-name": "Group 4882",
    transform: "translate(30.592 30.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_32-3",
    "data-name": "Exclusion 32",
    d: "M7.99,5.538h0a15.8,15.8,0,0,1-2.408-.208c-.713-.111-1.475-.267-2.265-.464C1.882,4.511.85,4.146.807,4.13a1.706,1.706,0,0,0-.42-.066C.2,4.05.036,4.038.005,3.955s.04-.177.206-.343c.052-.052.337-.333.815-.731A16.742,16.742,0,0,1,2.694,1.658,12.291,12.291,0,0,1,4.932.509,8.35,8.35,0,0,1,6.177.139,6.273,6.273,0,0,1,7.46,0,5.041,5.041,0,0,1,8.693.149a4.72,4.72,0,0,1,1.2.49,5.458,5.458,0,0,1,1.144.893,7.649,7.649,0,0,1,1.053,1.359,3,3,0,0,1-.134.7,2.4,2.4,0,0,1-.274.574,2.337,2.337,0,0,1-.4.46,2.757,2.757,0,0,1-.506.355,4.3,4.3,0,0,1-1.274.433A8.258,8.258,0,0,1,7.99,5.538ZM7.28.493a7.592,7.592,0,0,0-4,1.391A13.56,13.56,0,0,0,1.2,3.524c-.139.139-.194.23-.173.288s.162.08.32.092a1.432,1.432,0,0,1,.352.055c.036.013.9.319,2.106.618a16.717,16.717,0,0,0,3.921.563h0a4.909,4.909,0,0,0,2.343-.47,2.063,2.063,0,0,0,1.1-1.75A4.475,4.475,0,0,0,7.28.493Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15815-3",
    "data-name": "Path 15815",
    d: "M15381.754,6039.743s1.223,1.792,2.213,1.813c0,0-1.158-1.054-1.074-1.666S15381.754,6039.743,15381.754,6039.743Z",
    transform: "translate(-15381.577 -6035.684)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4883-2",
    "data-name": "Group 4883",
    transform: "translate(10.495 30.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_32-4",
    "data-name": "Exclusion 32",
    d: "M7.938,5.251h0a10.875,10.875,0,0,1-1.584-.115,10.475,10.475,0,0,1-1.409-.309A10.558,10.558,0,0,1,2.658,3.85,10.937,10.937,0,0,1,.268,1.993L.211,1.936C.045,1.77-.02,1.661.005,1.593S.2,1.5.387,1.484a1.706,1.706,0,0,0,.42-.066c.027-.01.09-.039.184-.083A16.44,16.44,0,0,1,2.952.552,10.42,10.42,0,0,1,6.117,0,6.239,6.239,0,0,1,7.785.214a5.007,5.007,0,0,1,.8.3,4.681,4.681,0,0,1,.757.45,4.824,4.824,0,0,1,.7.623,5.533,5.533,0,0,1,.619.815,6.969,6.969,0,0,1,.525,1.028,9.37,9.37,0,0,1,.414,1.26,13.707,13.707,0,0,1-1.914.432A11.874,11.874,0,0,1,7.938,5.251ZM5.6.652a9.35,9.35,0,0,0-3.78.884c-.062.028-.1.046-.124.053a1.432,1.432,0,0,1-.352.055c-.158.012-.294.022-.32.092s.034.149.173.288a5.346,5.346,0,0,0,.849.58A16.463,16.463,0,0,0,3.791,3.5,12.79,12.79,0,0,0,8.713,4.672h0a6.488,6.488,0,0,0,2.456-.448A6.073,6.073,0,0,0,5.6.652Z",
    transform: "translate(11.597 5.251) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15815-4",
    "data-name": "Path 15815",
    d: "M15383.967,6039.743s-1.221,1.792-2.213,1.813c0,0,1.16-1.054,1.076-1.666S15383.967,6039.743,15383.967,6039.743Z",
    transform: "translate(-15372.547 -6035.981)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15816-2",
    "data-name": "Path 15816",
    d: "M14751.916,5968.24s-.369-3.613,1.811-2.919,1.063,4.864,0,4.726-.047,2.455,1.156,2.548,1.529,2.085,1.529,2.085",
    transform: "translate(-14750.943 -5934.707)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15817-2",
    "data-name": "Path 15817",
    d: "M14737.686,5910.951a4.443,4.443,0,0,1-1.389-3.336c.047-2.131-2.131-2.918-3.15-.6s.7,5.049.789,5.884,1.111,9.635,3.01,7.644.74.6.74.6-3.1,2.6-4.076-3.659-.463-5.328-1.76-8.478c.232-3.2,1.018-4.494,2.688-4.679s2.779,3.011,2.779,3.011l.369,1.668Z",
    transform: "translate(-14731.85 -5876.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15818-2",
    "data-name": "Path 15818",
    d: "M15728.141,5975.363s2.137,1.083,2.424-4.976c.391-3.1,1.781-3.706,1.924-3.848s1.391-4.74-2.211-4.419c0,0-2.457.749-2.137,5.667l-.82-4.027s.82-3.848,4.17-2.708,1.6,5.488,1.6,5.488-1.568.535-2.209,3.848c-.248,1.276-.373,3.444-.855,4.241A1.493,1.493,0,0,1,15728.141,5975.363Z",
    transform: "translate(-15680.191 -5930.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15819-2",
    "data-name": "Path 15819",
    d: "M15743.654,6001.433v-.512s1.176,1.888,1.5,1.354.643-1.247-.283-1.782-2.246,1.568-1.891,2.887,2.209,1.247.678,2.922c0,0-1.461,1.069-2.031.784,0,0,2.887-2.031,1.354-2.815a2.26,2.26,0,0,1-.963-2.637s.572-2,2.068-1.853a2.346,2.346,0,0,1,1.961,1.141s.426,1.425-.607,1.853S15743.654,6001.433,15743.654,6001.433Z",
    transform: "translate(-15693.817 -5967.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15821-2",
    "data-name": "Path 15821",
    d: "M15006.152,6003.643c-.295.632.76.4,1.117.886s.125-.548.125-.548S15006.447,6003.01,15006.152,6003.643Z",
    transform: "translate(-14993.116 -5971.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15822-2",
    "data-name": "Path 15822",
    d: "M15110.9,6007.365s.254,1.054,0,1.413,1.477.042,1.477-.8-1.477-.612-1.477-.612",
    transform: "translate(-15092.933 -5974.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_40-2",
    "data-name": "Exclusion 40",
    d: "M2.036,4.071A2.036,2.036,0,0,1,1.243.16,2.036,2.036,0,0,1,2.828,3.911,2.023,2.023,0,0,1,2.036,4.071Zm0-2.683a.648.648,0,1,0,.648.648A.648.648,0,0,0,2.036,1.388Z",
    transform: "translate(14.21 31.178)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185",
    transform: "translate(-707.68 -208.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_885",
    "data-name": "Ellipse 885",
    transform: "translate(1003 392)",
    fill: "none",
    stroke: "#ca353b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 33,
    y2: 29,
    transform: "translate(1009.5 399.5)",
    fill: "none",
    stroke: "#ca353b",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatauser);
export default __webpack_public_path__ + "static/media/nodatauser.e4a971f03855e07cf2f6f9fa8ef4f3aa.svg";
export { ForwardRef as ReactComponent };